import { CloseButton, Drawer, Heading, Image, Portal, Span, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import NavItems from './NavItems'

const NavbarDrawer = (props) => {
  return (
    <Drawer.Root placement={'start'}>
      <Drawer.Trigger asChild>
        {props.children}
      </Drawer.Trigger>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner padding="4">
          <Drawer.Content rounded={24} boxShadow={'md'} h={'60%'}>
            <Drawer.Header>
              <Drawer.Title>
                <Image
                w={{'2xl': '130px', base: '100px'}}
                src={require('../../assets/logo.png')}
                />
              </Drawer.Title>
            </Drawer.Header>
            <Drawer.Body>
              <Text fontFamily={'Onest'} fontSize={'sm'}>
                Thank you for visiting Escrutin, your trusted partner in efficient and transparent voting solutions.
              </Text>

              <Heading mt={2} fontFamily={'Outfit'} fontSize={'sm'}>
                Navigation
              </Heading>
              <VStack mt={4} gap={1} align={'start'}>
                {
                    props.navItems?.map((elt, index)=> <NavItems data={elt}/>
                    )
                }
              </VStack>

            </Drawer.Body>
            
            <Drawer.Footer justifyContent={'center'}>
                <Text fontFamily={'Outfit'} fontSize={'xs'}>
                    &copy; 2025 eScrutin. All Rights Reserved.
                </Text>
            </Drawer.Footer>
            <Drawer.CloseTrigger rounded={'full'} asChild>
              <CloseButton size="sm" />
            </Drawer.CloseTrigger>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  )
}

export default NavbarDrawer